import React from 'react'
import Drawer from 'components/Drawer'
import { TitleText, SubTitleText, PaddingTop,NavigateSpan } from '../StyleComponents/style'
import AntdAvatar from 'components/Avatar'
import Facebook from 'components/icons/SocialMediaIcons/Facebook.svg'
import Instagramicon from 'components/icons/SocialMediaIcons/Instagramicon.svg'
import Interneticon from 'components/icons/SocialMediaIcons/Interneticon.svg'
import LinkedInIcon from 'components/icons/SocialMediaIcons/LinkedInIcon.svg'
import TwitterIcon from 'components/icons/SocialMediaIcons/TwitterIcon.svg'
import Youtubeicon from 'components/icons/SocialMediaIcons/Youtubeicon.svg'
import { FooterFlex } from 'modules/Students/Partials/StudentsBulkUpload/Style/style'
import Button from 'components/Button'
import { useNavigate, useParams } from 'react-router-dom'
import { EditorContent } from 'components/RichEditor/ContentStyles'


const ViewCorporate = ({ viewCorporate, setViewCorporate, viewCompanyDetails,  setViewCompanyDetails, setIsModalVisible}) => {
  const navigate = useNavigate()
    
    const onClickLink = (link) => {
      if (!link.startsWith('http://') && !link.startsWith('https://')) {
        link = 'https://' + link;
      }
    
      // Open the link in a new tab
      const newTab = window.open('', '_blank');
      
      // Set the new tab's location to the link after a delay
      setTimeout(() => {
        newTab.location.href = link;
      }, 100);
    }
    const uploadFooter = () => {
        return (
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Button.Danger
              text="Delete"
              onClick={() => {
                setViewCorporate(false);
                setIsModalVisible(true);
              }}
            />
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button.Secondary
                text="Edit"
                onClick={() =>
                    navigate(`/corporate/editCorporate/${viewCompanyDetails?.id}`)
                  }
                // onClick={() => {
                //   setFile();
                //   setActionDrawer(false);
                // }}
              />
              <Button.Primary
                htmlType="submit"
                form="bulkUpload"
                text="Done"
                // disable={Object?.keys(bulkUploadResult)?.length === 0}
                onClick={() => {
                  setViewCorporate(false)
                }}
              />
            </div>
          </div>
        )
      }
  const content = () => {
    return (
    <>

    <TitleText>
        Company Logo
    </TitleText>

    <AntdAvatar
          size={80}
                style={{
                  verticalAlign: 'middle',
                }}
                font={'40px'}
                src={viewCompanyDetails?.logo?.url}
                IconName={viewCompanyDetails?.companyName?.split('')[0]}
                shape='square'
              ></AntdAvatar>
<PaddingTop>
<TitleText>
        Company Name
    </TitleText>
    <SubTitleText transform={true}>
        {viewCompanyDetails?.companyName?.toLowerCase()}
    </SubTitleText>
    </PaddingTop>
    {viewCompanyDetails?.shortForm &&
<PaddingTop>

    <TitleText>
        Company Name (Short Form)
    </TitleText>
    <SubTitleText>
        {viewCompanyDetails?.shortForm}
    </SubTitleText>
    </PaddingTop>
  }
{viewCompanyDetails?.sector &&
    <PaddingTop>

    <TitleText>
        Company Sector
    </TitleText>
    <SubTitleText>
        {viewCompanyDetails?.sector}
    </SubTitleText>
    </PaddingTop>
  }
{viewCompanyDetails?.website &&
    <PaddingTop>

<TitleText>
    Company Website
</TitleText>
<SubTitleText>
<NavigateSpan onClick={() => onClickLink(viewCompanyDetails?.website)}> {viewCompanyDetails?.website} </NavigateSpan>
</SubTitleText>
</PaddingTop>
  }
  {viewCompanyDetails?.description &&
<PaddingTop>


<TitleText>
   About Company 
</TitleText>
<EditorContent
                dangerouslySetInnerHTML={{
                  __html: viewCompanyDetails?.description || '',
                }}
              />
</PaddingTop>
  }
  {viewCompanyDetails?.contactDetails?.length > 0 &&
<PaddingTop>
  
<TitleText>
   Contact
</TitleText>
{  viewCompanyDetails?.contactDetails?.map((poc, index) => (
        <div key={index}>
          {/* If index is 0, show as Primary */}
          {index === 0 ? (
            <>
              <SubTitleText>POC Name (Primary): {poc.pocName}</SubTitleText>
              <SubTitleText>POC Number (Primary): {poc.pocNumber}</SubTitleText>
              <SubTitleText>POC Email (Primary): <span>{poc.pocEmail}</span></SubTitleText>
            </>
          ) : (
            <>
              <SubTitleText>POC Name ({index + 1}): {poc.pocName}</SubTitleText>
              <SubTitleText>POC Number ({index + 1}): {poc.pocNumber}</SubTitleText>
              <SubTitleText>POC Email ({index + 1}):  <span>{poc.pocEmail}</span></SubTitleText>
            </>
          )}
          <br />
        </div>
      ))}

</PaddingTop>
  }
  {viewCompanyDetails?.socialDetails?.length > 0 && 
<PaddingTop>

<TitleText>
   Social Media
</TitleText>
{/* {data.socials.includes('internet') && (
<SubTitleText>

            <img
              src={Interneticon}
              alt="Internet Icon"
              style={{ width: '24px', height: '24px', marginRight: '5px' }}
            /> 
                &nbsp; Internet : <span>www.instagram.com/xyz</span>
         
          
</SubTitleText>
 )} */}



{viewCompanyDetails?.socialDetails?.some(item => item?.media?.toLowerCase() === 'facebook') && (
    <SubTitleText>
            <img
              src={Facebook}
              alt="Internet Icon"
              style={{ width: '24px', height: '24px', marginRight: '5px' }}
            />
             &nbsp; Facebook : <NavigateSpan onClick={() => onClickLink(viewCompanyDetails?.socialDetails?.find(item => item?.media?.toLowerCase() === 'facebook')?.link)}>{viewCompanyDetails?.socialDetails?.find(item => item?.media?.toLowerCase() === 'facebook')?.link}</NavigateSpan>
            </SubTitleText>
          )}
          {viewCompanyDetails?.socialDetails?.some(item => item?.media?.toLowerCase() === 'instagram') && (
                <SubTitleText>
            <img
              src={Instagramicon}
              alt="Instagram Icon"
              style={{ width: '24px', height: '24px', marginRight: '5px' }}
            />
  &nbsp; Instagram : <NavigateSpan onClick={() => onClickLink(viewCompanyDetails?.socialDetails?.find(item => item?.media?.toLowerCase() === 'instagram')?.link)}>{viewCompanyDetails?.socialDetails?.find(item => item?.media?.toLowerCase() === 'instagram')?.link}</NavigateSpan>
</SubTitleText>
          )}
{viewCompanyDetails?.socialDetails?.some(item => item?.media?.toLowerCase() === 'linkedin') && (
             <SubTitleText>
            <img
              src={LinkedInIcon}
              alt="Linkedin Icon"
              style={{ width: '24px', height: '24px', marginRight: '5px' }}
            />
  &nbsp; Linkedin : <NavigateSpan onClick={() => onClickLink(viewCompanyDetails?.socialDetails?.find(item => item?.media?.toLowerCase() === 'linkedin')?.link)}>{viewCompanyDetails?.socialDetails?.find(item => item?.media?.toLowerCase() === 'linkedin')?.link}</NavigateSpan>

</SubTitleText>
          )}
{viewCompanyDetails?.socialDetails?.some(item => item?.media?.toLowerCase() === 'youtube') && (
             <SubTitleText>

            <img
              src={Youtubeicon}
              alt="Youtube Icon"
              style={{ width: '24px', height: '24px', marginRight: '5px' }}
            />
  &nbsp; Youtube : <NavigateSpan onClick={() => onClickLink(viewCompanyDetails?.socialDetails?.find(item => item?.media?.toLowerCase() === 'youtube')?.link)}>{viewCompanyDetails?.socialDetails?.find(item => item?.media?.toLowerCase() === 'youtube')?.link}</NavigateSpan>

            </SubTitleText>
          )}
{viewCompanyDetails?.socialDetails?.some(item => item?.media?.toLowerCase() === 'xlink') && (
             <SubTitleText>

            <img
              src={TwitterIcon}
              alt="Twitter Icon"
              style={{ width: '24px', height: '24px', marginRight: '5px' }}
            />
  &nbsp; Twitter : <NavigateSpan onClick={() => onClickLink(viewCompanyDetails?.socialDetails?.find(item => item?.media?.toLowerCase() === 'xlink')?.link)}>{viewCompanyDetails?.socialDetails?.find(item => item?.media?.toLowerCase() === 'xlink')?.link}</NavigateSpan>

            </SubTitleText>
          )}
          

</PaddingTop>
  }

    </>
    )
  }
  return (
    <Drawer
      width="40%"
      title={'Coporate Details'}
      placement="right"
      closable={true}
      onClose={() => {
        setViewCompanyDetails(null)
        setViewCorporate(false)
      }}
      visible={viewCorporate}
      content={content()}
      footer={uploadFooter()}
    />
  )
}

export default ViewCorporate
